// @flow
import packageInfo from '../../package.json';
import { Licenses } from '../types/common';

import { BasePath, RootUrl } from './paths';

const Envs = {
  DEV: 'DEV',
  PRELIVE: 'PRELIVE',
  PROD: 'PROD',
};
const hosted = process.env.REACT_APP_ENV !== undefined;
const env = process.env.REACT_APP_ENV === 'PROD' ? Envs.PROD : Envs.PRELIVE;

const buildId = process.env.REACT_APP_BUILD_ID;

const tld = window.location.hostname === 'localhost'
  ? window.config.LICENSE.toLowerCase()
  : window.location.hostname.substring(window.location.hostname.lastIndexOf('.') + 1);

const ApiUrls = {
  [Envs.PRELIVE]: `https://wapi.prelive.winamax.${tld}/`,
  [Envs.PROD]: `https://wapi.winamax.${tld}/`,
};

const RecaptchaKeys = {
  [Envs.PRELIVE]: '6Ld5KeQUAAAAABkWTg6LbhfltpMbxER2Tg1_gALx',
  [Envs.PROD]: '6Lec8eMZAAAAAK2C8_pEuJpZwHrzw8CMH5w7V_aY',
};

const siteUrl = hosted ? `${RootUrl}${BasePath}` : 'https://localhost:3000';

const rand = size =>
  Math.random()
    .toString(36)
    .substring(2, size + 2);

const FranceConnectConfigs = {
  [Envs.PRELIVE]: {
    apiURL: 'https://fcp.integ01.dev-franceconnect.fr/api/v1',
    clientId: 'f18f9b3fe7977365a92806d1efd9696a7384ed3196eede0f7a870873a5f5016f',
    state: rand(8),
    nonce: rand(8),
    callBackUrl: `${siteUrl}/data-callback`,
    hide: true,
  },
  [Envs.PROD]: {
    apiURL: 'https://fcp.integ01.franceconnect.fr/api/v1',
    clientId: 'b101aa6db76315b30d8c4f03ab3fc3f2b9d37696a41483f3a96be111b06a778b',
    state: rand(8),
    nonce: rand(8),
    callBackUrl: `${siteUrl}/data-callback`,
    hide: true,
  },
};

const RefreshTokenUrls = {
  [Envs.PRELIVE]: `https://auth-api-eu-west-3.prelive.winamax.${tld}/core/authentication/token/refresh`,
  [Envs.PROD]: `https://auth-api-eu-west-3.winamax.${tld}/core/authentication/token/refresh`,
};

const getLicence = () => {
  return (window.config && window.config.LICENSE) || Licenses.FR;
};

const getDomainName = (hostName) => {
  return hostName.substring(hostName.lastIndexOf('.', hostName.lastIndexOf('.') - 1) + 1);
};

const isPokerEmbedded = (window.config && window.config.IS_POKER_EMBEDDED) || false;
const isBettingEmbedded = (window.config && window.config.IS_BETTING_EMBEDDED) || false;

const lockedReferralCode = (window.config && window.config.REFERRAL_CODE) || null;

export default {
  version: packageInfo.version,
  env,
  buildId,
  siteURL: siteUrl,
  apiURL: ApiUrls[env],
  apiNS: 'operator/api/registration',
  apiNSDeposit: 'pcidss/front/deposit',
  apiNSToken: 'core/authentication/token/refresh',
  apiNSTagCommander: 'operator/tag-commander',
  recaptchaKey: RecaptchaKeys[env],
  recaptchaRedirectionSeconds: 20,
  googlePlacesKey: 'AIzaSyA5YVGNFu8KuL-yFIdEYZhCDE9wpD5rkHE',
  franceConnect: FranceConnectConfigs[env],
  isDebug: true,
  isMockUp: false,
  isForce: false,
  hosted: hosted,
  jwt: '1.5.158281FFD',
  licence: getLicence(),
  maxAmount: 500,
  depositAmount: 20,
  wireTransfer: {
    reference: '7202659',
    beneficiary: 'WINAMAX',
    iban: 'FR76 30003 01678 00120006758 75',
    swift: 'SOGEFRPP',
    bankCode: '30003',
  },
  nameCookieJWT: '_GTM',
  expCookieJWT: 18, // in minute
  isProd: env === Envs.PROD,
  refreshToken: {
    url: RefreshTokenUrls[env],
    beforeCallRefreshTokenMin: 5,
    defaultTokenDurationMin: 16,
    intervalCheckTokenSec: 60,
  },
  endpointRefreshToken: 'APISID',
  socket: {
    timeout: 5000,
    reconnectionAttempts: 2,
  },
  successScreenDuration: 3000,
  cookies: {
    path: '/',
    domain: getDomainName(window.location.hostname),
    secure: false,
  },
  upload: {
    maxSize: 8000,
    types: [
      {
        value: 'image/jpeg',
        label: 'JPEG',
      },
      {
        value: 'image/png',
        label: 'PNG',
      },
      {
        value: 'application/pdf',
        label: 'PDF',
      },
    ],
  },
  requestTimeout: 10000,
  places: {
    position: {
      latitude: 48.8534,
      longitude: 2.3488,
    },
  },
  session: {
    getURL: `${window.location.origin}/serverstatus.php`,
    headerName: 'GTM',
    devSessionId: 'd/2DnrdT1yaVTqP8e5ZNTtdJkqqgLZih3dKBYlJvqVjd1NFX4I0n/lw3G3FNR9dX',
    maxRetry: 3,
    debounceRetry: 400,
  },
  analytics: {
    cookie: {
      name: 'winacookie',
      key: 'winaanalytics',
    },
    trackingId: 'UA-16886136-1',
  },
  tagManager: {
    gtmId: 'GTM-TX897J',
  },
  registerWithEmailOnly: false,
  specialOffer: false,
  tracker: window.config && window.config.TAG,
  license: getLicence(),
  lang: (window.config && window.config.LANG) || 'FR',
  isPokerEmbedded,
  isBettingEmbedded,
  isEmbedded: isPokerEmbedded || isBettingEmbedded,
  landingName: window.config.LANDING_NAME,
  captchaKey: '1a245b65-2c7e-432f-b7dc-0a82de6a9f00',
  shouldUseHcaptcha: window.config.USE_HCAPTCHA ?? false,
  lockedReferralCode,
};
